const brands = ['Hyundai', 'Toyota']
const models = ['i30', 'i20', 'Yaris', 'Corolla']
const colors = ['czerwony', 'niebieski', 'zielony', 'czarny', 'biały', 'złoty', 'srebrny', 'miedziany'];


  export {brands, colors, models};